export default "__VITE_ASSET__D3oLEOuJ__"